<template>
  <div class="date-picker-container">
    <span v-if="isWrongEntry"
          class="date-picker-container error-message">{{ createChapterStudioConstant.ERROR_MESSAGE.END_DATE }}</span>
    <div class="date-picker-row">
      <!-- Start Date -->
      <div class="date-picker-column">
        <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="auto"
            offset-y
            transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
                class="date-picker-activator"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon class="calendar-icon" color="primary">far fa-calendar-alt</v-icon>
              <span class="date-value">{{ startDate || "Select a date" }}</span>
              <i v-if="hasStartDate" aria-hidden="true"
                 class="fa fa-times clear-icon"
                 @click.stop="clearStartDate"
              >
              </i>
            </div>
          </template>
          <v-date-picker
              v-model="startDate"
              :min="initialStartDate"
              :first-day-of-week="1"
              :locale="'en'"
              @change="updateStartDate"
          ></v-date-picker>
        </v-menu>
      </div>

      <!-- End Date -->
      <div :class="['date-picker-column', !hasStartDate && 'date-picker-column--disabled']">
        <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="auto"
            :disabled="!hasStartDate"
            offset-y
            transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
                class="date-picker-activator"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon class="calendar-icon" color="primary">far fa-calendar-alt</v-icon>
              <span class="date-value">{{ endDate || "Select a date" }}</span>
              <i v-if="hasEndDate" aria-hidden="true"
                 class="fa fa-times clear-icon"
                 @click.stop="clearEndDate">
              </i>
            </div>
          </template>
          <v-date-picker
              v-model="endDate"
              :first-day-of-week="1"
              :locale="'en'"
              :min="startDate"
              @change="updateEndDate"
          ></v-date-picker>
        </v-menu>
      </div>
    </div>

  </div>
</template>

<script>
import { createChapterStudioConstant } from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";

export default {
  props: {
    startDateLabel: {
      type: String,
      required: true,
    },
    endDateLabel: {
      type: String,
      required: true,
    },
    startDateValue: {
      type: String,
    },
    endDateValue: {
      type: String,
    },
  },
  data() {
    return {
      initialStartDate: "",
      startDate: "",
      endDate: "",
      startMenu: false,
      endMenu: false,
      isWrongEntry: false,
      createChapterStudioConstant,
      showStartedDateCloseIcon: true,
    };
  },
  created() {
    if (this.startDateValue && this.startDateValue.length) {
      const today = new Date().toISOString().slice(0, 10);
      this.startDate = this.startDateValue;
      this.initialStartDate = this.startDateValue > today ? today : this.startDateValue;
    } else {
      const newDate = new Date();
      this.initialStartDate = newDate.toISOString().slice(0, 10);
    }
    if (this.endDateValue && this.endDateValue.length) {
      this.endDate = this.endDateValue;
    }
  },
  computed: {
    hasStartDate() {
      return this.startDate && this.startDate.length;
    },
    hasEndDate() {
      return this.endDate && this.endDate.length;
    },
  },
  methods: {
    updateStartDate() {
      this.startMenu = false;
      this.validateDateRange();
    },
    updateEndDate() {
      this.endMenu = false;
      this.validateDateRange();
    },
    clearStartDate() {
      this.startDate = "";
      this.validateDateRange();
    },
    clearEndDate() {
      this.endDate = "";
      this.validateDateRange();
    },
    validateDateRange() {
      if (this.endDate && new Date(this.endDate) < new Date(this.startDate)) {
        this.isWrongEntry = true;
        setTimeout(() => {
          this.isWrongEntry = false;
        }, 5000);
        this.endDate = "";
      }
      this.emitDateRange();
    },
    emitDateRange() {
      const { startDate, endDate } = this;
        this.$emit("updateDateRange", {
          startDate,
          endDate,
        });
        },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.date-picker-container {
  font-family: Roboto, 'sans-serif';

  .error-message {
    color: $ypo-error-red;
    font-size: 12px;
  }

  .date-picker-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    flex-direction: column;

    @include breakpointMin(sm) {
      flex-direction: row;
    }

    .date-picker-column {
      width: 100%;
      margin-bottom: 12px;

      @include breakpointMin(sm) {
        width: 40%;
        margin-bottom: 16px;
      }

      &--disabled {
        .calendar-icon, .date-value {
          opacity: 0.6;
        }
      }

      .date-picker-activator {
        display: flex;
        align-items: center;
        padding: 10px 10px 10px 3px;
        border-bottom: 1px solid $mild-grey;
        cursor: pointer;
        user-select: none;
      }

      .date-picker-activator:hover {
        border-bottom: 1px solid #000;
      }

      .calendar-icon {
        margin-right: 10px;
        font-size: 16px;
      }

      .date-value {
        flex: 1;
        font-size: 14px;
        color: #333;
      }

      .clear-icon {
        cursor: pointer;
        margin-left: auto;
      }
    }
  }
}


</style>
